import { i18n } from "@/config/i18n";

export default {
  name: "VantageBonus088",
  data() {
    return {
      showCopyToast: false,
      showImageModal: false,
      showGuideModal: false,
      highlights: [
        { value: '0.88%', label: i18n.global.t('blog.vantagebonus.highlightDailyLabel'), icon: 'fas fa-percentage' },
        { value: '$888', label: i18n.global.t('blog.vantagebonus.highlightMaxLabel'), icon: 'fas fa-trophy' },
        { value: i18n.global.t('blog.vantagebonus.highlightFreqValue'), label: i18n.global.t('blog.vantagebonus.highlightFreqLabel'), icon: 'fas fa-calendar-check' },
      ],
      joinConditions: [
        { icon: 'fas fa-toggle-on',  text: i18n.global.t('blog.vantagebonus.join1') },
        { icon: 'fas fa-dollar-sign', text: i18n.global.t('blog.vantagebonus.join2') },
        { icon: 'fas fa-server',     text: i18n.global.t('blog.vantagebonus.join3') },
      ],
      rewardConditions: [
        { icon: 'fas fa-lock',       text: i18n.global.t('blog.vantagebonus.reward1') },
        { icon: 'fas fa-clock',      text: i18n.global.t('blog.vantagebonus.reward2') },
        { icon: 'fas fa-chart-line', text: i18n.global.t('blog.vantagebonus.reward3') },
        { icon: 'fas fa-coins',      text: i18n.global.t('blog.vantagebonus.reward4') },
      ],
      warnings: [
        { icon: 'fas fa-times-circle', text: i18n.global.t('blog.vantagebonus.warn1') },
        { icon: 'fas fa-ban',          text: i18n.global.t('blog.vantagebonus.warn2') },
        { icon: 'fas fa-exclamation',  text: i18n.global.t('blog.vantagebonus.warn3') },
        { icon: 'fas fa-flag-checkered', text: i18n.global.t('blog.vantagebonus.warn4') },
        { icon: 'fas fa-info-circle',  text: i18n.global.t('blog.vantagebonus.warn5') },
      ],
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    goToContact() { this.$router.push({ name: 'Contact' }); },
    copyCode(code) {
      navigator.clipboard.writeText(code).catch(() => {});
      this.showCopyToast = true;
      setTimeout(() => { this.showCopyToast = false; }, 2000);
    },
    openImageModal() { this.showImageModal = true; },
    closeImageModal() { this.showImageModal = false; },
    openGuideModal() { this.showGuideModal = true; },
    closeGuideModal() { this.showGuideModal = false; },
  },
};
